<template>
  <v-card>
    <v-card-title>
      <span class="headline"
        >Cambiar Etiquetas pedido: {{ $_str_pad_left(pedidoId) }}</span
      >
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <SearchTagsInput @selected="tag_id = $event" :etiquetasActual="etiquetasActual"></SearchTagsInput>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="$emit('form:close')">
        Cancelar
      </v-btn>
      <v-btn
        color="blue darken-1"
        :loading="is_submit"
        dark
        @click="cambiarStatus"
      >
        Cambiar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import EventBus from "../EventBus";
import axios from "axios";
import SearchTagsInput from "@components/SearchTagsInput";
export default {
  name: "FormSetTags",
  components: {
    SearchTagsInput,
  },
  props: {
    pedidoId: {
      type: Number,
      required: true,
      default: 0,
    },
    etiquetasActual: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      is_submit: false,
      tag_id: this.etiquetasActual,
    };
  },
  computed: {},
  methods: {
    cambiarStatus() {
      this.is_submit = true;
      axios
        .post("/api/pedidos/set-tags/" + this.pedidoId, {
          tag_id: this.tag_id,
        })
        .then((responseOk) => {
          this.is_submit = false;
          let {
            data: data_response,
            data: { message },
          } = responseOk;
          EventBus.$emit("tugarrafon:show-snackbar", { text_content: message });
          this.$emit("form:save", data_response);
        })
        .catch(() => {
          this.is_submit = false;
          EventBus.$emit("tugarrafon:show-snackbar", {
            text_content: "Ocurrió un error durante la petición",
          });
        });
    },
  },
};
</script>

<style scoped>
</style>
